import { appStore } from "entities/App";
import { GetSeaCardsFunc, useSavedCardsQuery } from "entities/SeaSavedCard";
import { SeaSearchRequestFunc, useSearchQuery, UseSearchQueryReturnType } from "entities/SeaSearchCard";
import { subscriptionStore } from "entities/Subscription";

type UseSeaSearchReturnType = {
  getSeaCards: GetSeaCardsFunc;
  seaSearchRequest: SeaSearchRequestFunc;
  seaSearchResponse: UseSearchQueryReturnType["searchResponse"];
  isSeaSearchLoading: boolean;
  isSeaSearchSuccess: boolean;
  isSeaSearchError: boolean;
};

export const useSeaSearch = ({ isAuthenticated }: { isAuthenticated: boolean }): UseSeaSearchReturnType => {
  const { searchRequest, searchResponse, isSearchSuccess, isSearchError, isSearchLoading } = useSearchQuery({
    isAuthenticated,
    setSubscription: (subscription) => ({
      type: subscriptionStore.actions.setSubscription.type,
      payload: subscription,
    }),
    setActivePaymentModal: (activePaymentModal) => ({
      type: subscriptionStore.actions.setActivePaymentModal.type,
      payload: activePaymentModal,
    }),
    setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached) => ({
      type: appStore.actions.setAppIntegrationRequestLimitReached.type,
      payload: appIntegrationRequestLimitReached,
    }),
    setWebAppRequestLimitReached: (webAppRequestLimitReached) => ({
      type: appStore.actions.setWebAppRequestLimitReached.type,
      payload: webAppRequestLimitReached,
    }),
  });
  const { getCards, isCardsLoading, isCardsSuccess, isCardsError } = useSavedCardsQuery({
    queryKey: ["checkSeaSavedCardExisting"],
  });

  return {
    getSeaCards: getCards,
    seaSearchRequest: searchRequest,
    seaSearchResponse: searchResponse,
    isSeaSearchLoading: isSearchLoading || isCardsLoading,
    isSeaSearchSuccess: isSearchSuccess || isCardsSuccess,
    isSeaSearchError: isSearchError || isCardsError,
  };
};
